export const TRANSLATIONS = {
	en: {
		ACCESSIBILITY: {
			TEXT_SIZE: 'Text Size',
			LINE_HEIGHT: 'Line Height',
			CONTRAST: 'Contrast',
			SATURATION: 'Saturation',
			HIGHLIGHT_LINKS: 'Highlight Links',
			HIDE_IMAGES: 'Hide Images',
			PAUSE_ANIMATION: 'Pause Animations',
			DYSLEXIC_FONT: 'Dyslexia Font',
			BIG_CURSOR: 'Big Cursor',
			RESET: '♻️ Reset All',
			POSITION: '↔️ Widget Position',
		},
	},
	de: {
		ACCESSIBILITY: {
			TEXT_SIZE: 'Textgrößee',
			LINE_HEIGHT: 'Zeilenhöhe',
			CONTRAST: 'Kontrast',
			SATURATION: 'Sättigung',
			HIGHLIGHT_LINKS: 'Links hervorheben',
			HIDE_IMAGES: 'Bilder ausblenden',
			PAUSE_ANIMATION: 'Animationen pausieren',
			DYSLEXIC_FONT: 'Dyslexie-Schrift',
			BIG_CURSOR: 'Großer Cursor',
			RESET: '♻️ Alles zurücksetzen',
			POSITION: '↔️ Widget-Position',
		},
	},
};
